/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ partners: NonNullable<unknown>, amount: NonNullable<unknown> }} Partner_Billing_Board_Meta_Open_One_BlockedInputs */



/**
* | output |
* | --- |
* | "{partners} partners · 1 needs attention, listed first · {amount}" |
*
* @param {Partner_Billing_Board_Meta_Open_One_BlockedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_meta_open_one_blocked = /** @type {((inputs: Partner_Billing_Board_Meta_Open_One_BlockedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Meta_Open_One_BlockedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.partners} Partner · 1 erfordert Aufmerksamkeit, oben aufgeführt · ${i?.amount}`)
	return /** @type {LocalizedString} */ (`${i?.partners} partners · 1 needs attention, listed first · ${i?.amount}`)
});